import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { saveGlobalPageSize } from '../../utils/storageUtils';
import { resetReduxState } from '../actions';

const DEFAULT_PAGE_SIZE = 10;

interface GeneralState {
  globalPageSize: number;
}

const initialState: GeneralState = {
  globalPageSize: DEFAULT_PAGE_SIZE,
};

const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    setGlobalPageSize: (state, action: PayloadAction<number>) => {
      state.globalPageSize = action.payload;
      saveGlobalPageSize(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetReduxState, () => initialState);
  },
});

export const { setGlobalPageSize } = generalSlice.actions;
export default generalSlice.reducer;
